import { useNavigate } from 'react-router-dom'
import { promptInstall } from './pwaState'
import { usePwa } from './usePwa'

/**
 * "Download app" button for the top bar. One click installs: when the browser offers its install
 * dialog (Chrome, Edge, Samsung Internet) it opens right away. Otherwise (Safari, Firefox, or the
 * browser has not offered it yet) the button opens the /download page, which shows the QR code and
 * the steps for that browser. Hidden once the app is already running as an installed app.
 */
export default function InstallAppButton() {
  const { installed, installPromptAvailable } = usePwa()
  const navigate = useNavigate()
  if (installed) return null

  const handleClick = async () => {
    if (installPromptAvailable) {
      await promptInstall()
      return
    }
    navigate('/download')
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Download app"
      className="inline-flex h-11 items-center gap-2 px-[10px] text-white transition-colors hover:text-m1-violet"
    >
      <i className="ri-download-2-line text-xl" aria-hidden="true" />
      <span className="hidden text-[14px] tracking-[0.03em] md:inline">Download app</span>
    </button>
  )
}
